import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, ForkEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';
import { fetchCartStatus } from 'b2b-apps/shop/cart/redux/cartStatus/actionCreators';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { ExpressOrder } from 'b2b-apps/shop/expressOrder/api/ExpressOrder';
import {
  addItemsToCartFulfilled,
  addItemsToCartRejected,
  addItemsToWishlistFulfilled,
  addItemsToWishlistRejected,
  uploadCsvFulfilled,
  uploadCsvRejected,
  verifyFulfilled,
  verifyRejected,
} from 'b2b-apps/shop/expressOrder/redux/actionCreators';
import {
  ADD_EXPRESS_ORDER_ITEMS_TO_CART,
  ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST,
  UPLOAD_CSV,
  VERIFY,
} from 'b2b-apps/shop/expressOrder/redux/actionTypes';
import {
  AddItemsToCartAction,
  AddItemsToWishlistAction,
  UploadCsvAction,
  VerifyAction,
} from 'b2b-apps/shop/expressOrder/redux/types';
import { AddItemsToCartType } from 'b2b-common/core/cart/api/CartTypes';

function* addItemsToCartSaga(
  action: AddItemsToCartAction,
): Generator<CallEffect | PutEffect, void, AxiosResponse<AddItemsToCartType>> {
  const { data } = action.payload;

  try {
    const response = yield call(requestApiSaga, ExpressOrder.addItemsToCart(data));

    yield put(addItemsToCartFulfilled(response.data));
    yield put(fetchCartStatus());
  } catch (error) {
    yield put(addItemsToCartRejected(parseError(error)));
    yield put(reportError(action.type, error, action.payload));
  }
}

function* addItemsToWishlistSaga(
  action: AddItemsToWishlistAction,
): Generator<CallEffect | PutEffect, void, AxiosResponse> {
  const { data } = action.payload;

  try {
    const response = yield call(requestApiSaga, ExpressOrder.addItemsToWishlist(data));

    yield put(addItemsToWishlistFulfilled(response.data));
  } catch (error) {
    yield put(addItemsToWishlistRejected(parseError(error)));
    yield put(reportError(action.type, error, action.payload));
  }
}

function* uploadCsvSaga(action: UploadCsvAction): Generator<CallEffect | PutEffect, void, AxiosResponse> {
  const { file } = action.payload;

  try {
    const response = yield call(requestApiSaga, ExpressOrder.uploadCsv(file));

    yield put(uploadCsvFulfilled(response.data));
  } catch (error) {
    yield put(uploadCsvRejected(parseError(error)));
    yield put(reportError(action.type, error, action.payload));
  }
}

function* verifySaga(action: VerifyAction): Generator<CallEffect | PutEffect, void, AxiosResponse> {
  const { data } = action.payload;

  try {
    const response = yield call(requestApiSaga, ExpressOrder.verify(data));

    yield put(verifyFulfilled(response.data));
  } catch (error) {
    yield put(verifyRejected(parseError(error)));
    yield put(reportError(action.type, error, action.payload));
  }
}

function* expressOrderSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeLatest(ADD_EXPRESS_ORDER_ITEMS_TO_CART, addItemsToCartSaga),
    takeLatest(ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST, addItemsToWishlistSaga),
    takeLatest(UPLOAD_CSV, uploadCsvSaga),
    takeLatest(VERIFY, verifySaga),
  ]);
}

export { expressOrderSaga };
